export default __webpack_public_path__ + "static/media/bikash.41d6ea26.jpg";